{{#if testIdPrefix}}
  {{sp_select_tag (sp_select_name prefix "[" name "]")
    choices=select_items
    includeBlank=false
    selected=value
    navigation="drilldown"
    selectableBranches=true
    searchAllLevels=true
    searchable=true
    id=id
    testId=(dasherize (concat testIdPrefix name))
    required=required
    disabled=disabled
  }}
{{else}}
  {{sp_select_tag (sp_select_name prefix "[" name "]")
    choices=select_items
    includeBlank=false
    selected=value
    navigation="drilldown"
    selectableBranches=true
    searchAllLevels=true
    searchable=true
    id=id
    required=required
    disabled=disabled
  }}
{{/if}}
